import { render, staticRenderFns } from "./Ersatzmitglieder_Kirchenrat.vue?vue&type=template&id=8f8164d2&scoped=true&"
import script from "./Ersatzmitglieder_Kirchenrat.vue?vue&type=script&lang=js&"
export * from "./Ersatzmitglieder_Kirchenrat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8164d2",
  null
  
)

export default component.exports